import { colors } from '@aloft/toolkit-sui';
import { StyleSheet } from '@react-pdf/renderer';

import { Flex } from '../../../summary/components/Flex.js';
import { Typography } from '../../../summary/components/Typography.js';

export const CostApproachSummarySourceLine = ({ value }: { value: string }) => (
  <Flex alignItems="center" gap="6px" style={styles.bulletWrapper}>
    <Flex
      height="6px"
      width="6px"
      borderRadius="50%"
      backgroundColor="textSecondary"
      style={styles.bullet}
    />
    <Typography variant="body2">{value}</Typography>
  </Flex>
);

const styles = StyleSheet.create({
  bulletWrapper: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: '6px',
  },
  bullet: {
    width: '4px',
    height: '4px',
    borderRadius: '2px',
    backgroundColor: colors.textSecondary,
  },
});
